import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, FullPageWrapper, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useTeamsContext } from 'pages/settings/pages/teams/context/teamsContext'
import { ManageTeamMembers } from 'pages/settings/pages/teams/ui/ManageTeamMembers/ManageTeamMembers'
import { TeamsPath } from 'pages/settings/pages/teams/route/teamsPath'

export const ManageTeamMembersLayout = observer(() => {
  const { teamId: teamIdParam } = useParams<{ teamId: string }>()
  const teamId =
    teamIdParam !== null && teamIdParam !== undefined && teamIdParam !== ''
      ? Number(teamIdParam)
      : NaN

  const teamsStore = useTeamsContext()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    teamsStore.resetAllTableSelections()
    setLoading(true)

    let cancelled = false

    const run = async () => {
      await teamsStore.initManageTeamMembers(teamId)

      if (!cancelled) {
        setLoading(false)
      }
    }

    void run()

    return () => {
      cancelled = true
    }
  }, [teamId, teamsStore])

  if (loading) {
    return (
      <FullPageWrapper>
        <SpinnerLoader ariaLabel={'ManageTeamMembersLayout'} />
      </FullPageWrapper>
    )
  }

  if (!teamsStore.currentTeam) {
    return (
      <FullPageWrapper>
        <Typography variant='body-md-regular' ariaLabel='ManageTeamMembersNotFound'>
          Team not found.
        </Typography>
        <Button
          text='Back to Teams'
          typeBtn='stroke'
          icon='chevronLeft'
          onClick={() => uiStore.changeRoute({ path: TeamsPath.root })}
          aria-label={'ManageTeamMembersBackToTeams'}
        />
      </FullPageWrapper>
    )
  }

  return <ManageTeamMembers team={teamsStore.currentTeam} />
})
